import React, { Component } from 'react'
import { extendObservable } from 'mobx'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import { Route, withRouter } from 'react-router-dom'

import Spinner from '@components/spinner'
import Scroll from '@components/Scroll'
import Tabs from '@components/Tabs'
import Badge from '@components/Details/Badge'
import InfoBox from '@components/InfoBox'
import InfoIcon from '@components/Icon/Info'

import ParentAccountStore from './parent-account.store'

import DetailsTab from './DetailsTab'
import ProjectsTab from './ProjectsTab'
import ContractsTab from './ContractsTab'
import InvoicingEntitiesTab from './InvoicingEntitiesTab'
import InvoicingEntity from './InvoicingEntitiesTab/InvoicingEntity'
import AccountsOffices from './AccountsOfficesTab'
import Metric from './Metric'
import CopyButton from '../../components/CopyButton'

class ParentAccountPage extends Component {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string
      }).isRequired,
      url: PropTypes.string
    }).isRequired,
    history: PropTypes.object,
    staticData: PropTypes.object,
    growlStore: PropTypes.object
  }

  constructor(props) {
    super(props)

    extendObservable(this, {
      parentAccountStore: new ParentAccountStore(
        props.staticData,
        props.growlStore
      )
    })

    const parentAccountId = props.match.params.id
    this.parentAccountStore.load(parentAccountId)
  }

  renderLoader() {
    return <Spinner />
  }

  render() {
    const { match, history, staticData } = this.props

    const {
      loading,
      parentAccount,
      projectCount,
      projectFeedbackAvg
    } = this.parentAccountStore

    if (loading) {
      return this.renderLoader()
    }

    const tabs = [
      {
        tab: 'details'
      },
      {
        tab: 'projects'
      },
      {
        tab: 'contracts'
      },
      {
        tab: 'invoicing-entities',
        tabName: 'invoicing entities',
        roles: [
          'FeeManagement',
          'Accounting',
          'AdvancedExpertManagement',
          'ProjectManagement',
          'AdvancedReporting',
          'Admin'
        ]
      },
      {
        tab: 'accounts-and-offices',
        tabName: 'accounts&offices',
        roles: [
          'FeeManagement',
          'Accounting',
          'AdvancedExpertManagement',
          'ProjectManagement',
          'AdvancedReporting',
          'Admin'
        ]
      },
      {
        tab: 'metrics'
      }
    ]

    const urlMatch = match.url.match(/search/)
    const isLinkToFullPage = urlMatch && urlMatch.length > 0
    const { projectIdToUpdate } = Object.fromEntries(new URLSearchParams(this.props.location.search))
    return (
      parentAccount && (
        <Scroll>
          <div className='project-wrapper'>
            <div className='details-header'>
              <div className='info info--noLeft'>
                <div>
                  <div className='name-status-wrapper parent-account'>

                    <h1
                      className={isLinkToFullPage ? 'title-link' : ''}
                      onClick={() =>
                        isLinkToFullPage &&
                        history.push(`/parent-account/${parentAccount.id}`)
                      }
                    >
                      {parentAccount.parentAccountName}
                    </h1>
                    <CopyButton value={parentAccount.parentAccountName} />
                    {
                      projectIdToUpdate && <InfoBox theme='yellow' icon={<InfoIcon />}>
                        <span>Either select an existing invoicing entity or create a new one for <a target={'_blank'} href={`/project/${projectIdToUpdate}`}>this project</a>.</span>
                      </InfoBox>
                    }
                  </div>
                  <span className='code-label'>
                    {parentAccount.parentAccountCode}
                  </span>
                </div>
              </div>
              <Badge label='Projects' value={projectCount.count} />
              <Badge
                label='Feedback'
                hasStar={!!projectFeedbackAvg}
                onClick={this.showClientFeedbacks}
                value={projectFeedbackAvg}
              />
            </div>
            <div className='expert-tabs'>
              <Tabs ignoreExactMatches={['invoicing']} tabs={tabs} />
            </div>
            <div className='views-wrapper'>
              <Route
                exact
                path={match.url}
                render={props => (
                  <DetailsTab
                    {...props}
                    parentAccountStore={this.parentAccountStore}
                    staticData={staticData}
                  />
                )}
              />
              <Route
                exact
                path={match.url + '/projects'}
                render={props => (
                  <ProjectsTab {...props} parentAccount={parentAccount} />
                )}
              />
              <Route
                exact
                path={match.url + '/contracts'}
                render={props => (
                  <ContractsTab {...props} parentAccount={parentAccount} />
                )}
              />
              <Route
                exact
                path={match.url + '/invoicing-entities'}
                render={props => (
                  <InvoicingEntitiesTab
                    {...props}
                    parentAccount={parentAccount}
                  />
                )}
              />
              <Route
                exact
                path={match.url + '/invoicing-entities/:id'}
                component={InvoicingEntity}
              />
              <Route
                exact
                path={match.url + '/accounts-and-offices'}
                render={props => (
                  <AccountsOffices {...props} parentAccount={parentAccount} />
                )}
              />
              <Route
                exact
                path={match.url + '/metrics'}
                render={props => (
                  <Metric {...props} parentAccount={parentAccount} />
                )}
              />
            </div>
          </div>
        </Scroll>
      )
    )
  }
}

export default withRouter(
  inject('staticData', 'growlStore')(observer(ParentAccountPage))
)
